// extracted by mini-css-extract-plugin
export default {"form":"ConnectShipBobForm_form__fxLnc","body":"ConnectShipBobForm_body__sekUp","footer":"ConnectShipBobForm_footer__SXiBU","button":"ConnectShipBobForm_button__gDPTY"};